import type { JSX } from 'react';

import './DiscordInvite.less';

interface DiscordInviteProps {
  href: string;
}

export const DiscordInvite = ({ href }: DiscordInviteProps): JSX.Element => {
  return (
    <div className="discord-invite">
      <a href={href} target="_blank" rel="noopener noreferrer">
        <img
          width="50"
          height="50"
          src="https://res.cloudinary.com/between-worlds/image/upload/h_230,w_230/v1622221260/discord_xeis8i.png"
          alt="Discord Logo"
        />{' '}
        Join us on Discord
      </a>
    </div>
  );
};
